export enum eTypeSnackBar {
  success = "success",
  warning = "warning",
}
